import { apiHelper } from "./api_helper";

export const API_QUANHEGIADINH_ENDPOINT = "quan-he-gia-dinh";

export const quanHeGiaDinhApi = {
    SelectByHocSinh: (ts_hocsinh_id) => apiHelper.get(`${API_QUANHEGIADINH_ENDPOINT}/hoc-sinh/${ts_hocsinh_id}`),
    DeleteQHGD: (data) => apiHelper.post(`${API_QUANHEGIADINH_ENDPOINT}/delete-qhgd`, data),
    Insert: (data) => apiHelper.post(API_QUANHEGIADINH_ENDPOINT, data),
    Update: (data) => apiHelper.put(API_QUANHEGIADINH_ENDPOINT, data),
    Delete: (id) => apiHelper.delete(`${API_QUANHEGIADINH_ENDPOINT}/${id}`),
    Detail: (id) => apiHelper.get(`${API_QUANHEGIADINH_ENDPOINT}/${id}`)

}